/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import { SemeiaComorbidityCode } from "comorbidity/models/comorbidities-and-allergies-changed-journal-event";
import { getEnvironmentNameFromHostname } from "core/utils/runtime-environment";
export default class ComorbidityEditionFormComponent extends Component {
  get changeset() {
    const changeset = this.args.changeset;
    if (!changeset.get("comorbidities") || this.args.patient.therapeuticalArea?.id !== "mental") {
      return changeset;
    }
    const comorbidities = [...changeset.get("comorbidities")];

    // Compatibility layer for legacy codes stored in DBs.
    // Those codes are of the form "ICD-F10-0"
    // The same icd10 compliant code would be "F10.0"
    const compliantComorbidities = comorbidities.map(code => new SemeiaComorbidityCode(code).icd10Code);
    changeset.set("comorbidities", compliantComorbidities);
    return changeset;
  }
  get shouldDisplayDetection() {
    return getEnvironmentNameFromHostname(window.location.hostname) == "demo";
  }
}